import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { WithChildrenProps } from '@app/types/generalTypes';

const RequireAuth: React.FC<WithChildrenProps> = ({ children }) => {
 const currentVariant = process.env.REACT_APP_UI_VARIANT || 'control';
  const token = useAppSelector((state) => state.auth.token);

  if (!token) {
    let loginPath = '/auth/login'; // default for control

    if (currentVariant === 'user') {
      loginPath = '/auth/login-user';
    } else if (currentVariant === 'store') {
      loginPath = '/auth/login-store';
    }

    return <Navigate to={loginPath} replace />;
  }

  return <>{children}</>;
};

export default RequireAuth;
